import React, { useEffect, useState, useRef } from 'react';
import { fetchCompanyGroups, deleteCompanyGroup, getCompanyGroupById } from '../../utils/requestUtils';
import { useNavigate } from 'react-router-dom';
import CentralizedView from '../common/CentralizedView';
import NewButton from '../common/NewButton';
import TableRowActions from '../common/TableRowActions';
import ListPageLayout from '../common/ListPageLayout';

const CompanyGroupList = () => {
    const [groups, setGroups] = useState([]);
    const [filteredGroups, setFilteredGroups] = useState([]);
    const [queryString, setQueryString] = useState('');
    const [loading, setLoading] = useState(true);
    const [deletingId, setDeletingId] = useState(null);
    const inputQueryString = useRef(null);
    const navigate = useNavigate();

    useEffect(() => {
        fetchCompanyGroups().then(data => {
            setGroups(data);
            setFilteredGroups(data);
            setLoading(false);
        });
    }, []);

    useEffect(() => {
        if (inputQueryString.current) {
            inputQueryString.current.focus();
        }
    }, []);

    const handleEdit = (id) => {
        navigate(`/admin/companygroup?id=${id}`);
    };

    const handleDelete = async (id) => {
        if (window.confirm('Deseja realmente excluir este grupo?')) {
            try {
                setDeletingId(id);
                await deleteCompanyGroup(id);
                const updated = groups.filter(g => g.id !== id);
                setGroups(updated);
                setFilteredGroups(updated.filter(g => g.name.toLowerCase().includes(queryString.toLowerCase())));
            } catch (error) {
                console.error('Error deleting company group:', error);
                alert('Erro ao excluir o grupo. Tente novamente.');
            } finally {
                setDeletingId(null);
            }
        }
    };

    const handleInputChange = (e) => {
        const string = e.target.value;
        setQueryString(string);
        setFilteredGroups(groups.filter(g => g.name.toLowerCase().includes(string.toLowerCase())));
    };

    if (loading) return <div>Carregando...</div>;

    return (
        <CentralizedView>
            <ListPageLayout
                tableWidth={720}
                header={
                    <div style={{display: "flex", alignItems: "center", gap: '10px'}}>
                        <div className="header-label">Consulta de Grupos de Permissões</div>
                        <NewButton className={"new-button"} onClick={() => navigate('/admin/companygroup')}/>
                    </div>
                }
                filters={
                    <div style={{display: 'flex', justifyContent: 'space-between', alignItems: 'center', width: '100%'}}>
                        <input ref={inputQueryString} type="text" value={queryString} onChange={handleInputChange} placeholder="Buscar grupo..."/>
                    </div>
                }
            >
            <table>
                <thead>
                    <tr>
                        <th>Nome</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody style={{overflowY: 'auto'}}>
                    {filteredGroups.map((group, index) => (
                        <tr key={group.id}>
                            <td>{group.name}</td>
                            <td>
                                <TableRowActions
                                    actions={[
                                        {
                                            key: 'edit',
                                            label: 'Editar',
                                            type: 'edit',
                                            disabled: deletingId === group.id,
                                            onClick: () => handleEdit(group.id),
                                            buttonProps: {
                                                className: 'edit-button',
                                                'data-test': 'edit-company-group-button',
                                                disabled: deletingId === group.id,
                                            },
                                        },
                                        {
                                            key: 'delete',
                                            label: deletingId === group.id ? 'Excluindo...' : 'Excluir',
                                            disabled: deletingId === group.id,
                                            onClick: () => handleDelete(group.id),
                                            render: () => (
                                                <button
                                                    className="remove-button"
                                                    onClick={() => handleDelete(group.id)}
                                                    data-test="delete-company-group-button"
                                                    disabled={deletingId === group.id}
                                                >
                                                    {deletingId === group.id ? 'Excluindo...' : 'Excluir'}
                                                </button>
                                            ),
                                        },
                                    ]}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
                {filteredGroups.length === 0 && (<tfoot>{loading ? 'Carregando...' : `Nenhum item encontrado.`}</tfoot>)}
            </table>
            </ListPageLayout>
        </CentralizedView>
    );
};

export default CompanyGroupList; 